import React, {useState, useEffect,} from 'react';
import Api from '../../Api';
import Butao from '../../Components/Butao_list';
import Campo from '../../Components/Campo';
import Header from '../../Components/Header';
import { Spinner  } from "react-awesome-spinners";
import FinderSelect from 'react-finderselect';
import { Web } from '@material-ui/icons';
import Select from 'react-select';


export default ({InfIdUse, InfIdConta, IdUse, IdConta, setAddList, setUsuariosContServ, UsuariosContServ,  Dados, Avisando, Fechar, Id, setAlert, setAlertTipo, MsgDesativar}) => {

const [Titulo, setTitulo] = useState("Criar Conta Funcionário");
const [MsgErro, setMsgErro] = useState("");
const [Loading, setLoading] = useState(false);
const [Nome, setNome] = useState("");
const [Telefone, setTelefone] = useState("");
const [End, setEnd] = useState("");
const [Num, setNum] = useState("");
const [Bairro, setBairro] = useState("");
const [Cidade, setCidade] = useState("");
const [Estado, setEstado] = useState("");
const [IdGrupo, setIdGrupo] = useState("");
const [ListGrupo, setListGrupo] = useState([]);





 useEffect(() => {
          
      }, [IdGrupo])

   

 useEffect(() => {
       ListandoGrupo();     
      }, [])

 


    
 const ListandoGrupo = async ()=>{
    await Api.TAListGrupoClientes(Dados, IdConta, setListGrupo)
   }

const criando = ()=>{

  

    if(Nome !=="" && Nome !==" " && Nome !=="  " && Nome !=="   " && Nome !=="    " && Nome !=="     " && Nome !=="      "
    && Nome !=="       " && Nome !=="        " && Nome !=="         " && Nome !=="          " 
    && Nome !=="           " ){
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
        Api.TACriarFuncinariosClientes(IdGrupo, IdConta, InfIdUse,  IdUse,  Nome,    Telefone,    Estado, Cidade, Bairro, Num, End,  setMsgErro, setLoading, setAlertTipo, setAlert, setAddList);
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    } else {
        setMsgErro("Preencha o Nome Completo do Funcionário.")
    }

   
  }

  const printValue1 = (target) => {    
              setIdGrupo(target.value)  
              }
  

  
     
      
   

        return (
            <>
<div className="content-wrapper">
                <Header 
                Titulo={Titulo}
                Avisando={Avisando}
                Fechar={Fechar}
                />
               <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
            
              <div className="invoice p-3 mb-3">
              {/* title row */}
              <div className="row">
                <div className="col-12">
                  <h4>
                    <i className="far fa-address-book" /> Funcionário 
                  </h4>
                </div>
                {/* /.col */}
              </div>
              {/* info row */}
              <div className="row invoice-info">
                <div className="col-sm-4 invoice-col">
                  <address>
                    {Loading  ?
                    <>
                      <Spinner 
                      size={64}
                      color={"#5d0bf7"}
                      sizeUnit={'px'} 
                      /><br />
                      </>
                      :
                      <>
                    <div className="col-12">
                        <Butao 
                        style={"btn .btn-sm btn-info"}
                        titulo={"Salvar"}
                        onClick={()=>criando()}
                        />  
                    </div><br />
                    
                     {MsgErro !== "" &&
                    <>
                    <div class="alert alert-danger alert-dismissible">
                  
                  <h5><i class="icon fas fa-ban"></i> Alert!</h5>
                  {MsgErro}
                </div>
                   
                    </>
                    }
                    </>
                    }
                    
                   
                    
                    <strong>Nome do Funcionário</strong><br />
                    <div className="input_cadatro">
                             
                      
                      <input
                              type="text"
                              value={Nome}
                              onChange={t=>setNome(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Nome do Aluno"
                             
                            />
                            </div> 
                    <br />
                 
                   <strong>Telefone do Funcionário</strong><br />
                    <div className="input_cadatro">
                              
                              <Campo 
                                type={"tel"}
                                placeholder={"Digite Whatsapp"}
                                icon={"fas fa-phone"}
                                value={Telefone}
                                onChange={e=>setTelefone(e.target.value)}
                                mask={"(99)99999-9999"}
                                />

                            </div> 
                    <br />
              <strong>Grupo de Permissões</strong><br />
                    <Select
                   
                    onChange={(target) => printValue1(target)}
                    options={ListGrupo}
                    placeholder={"Escolha um Grupo"}
                  />    
                     
                    
            
                     
                  </address>
                    </div>
                      <div className="col-sm-4 invoice-col">
                    <address>
                      <strong>Endereço</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={End}
                              onChange={t=>setEnd(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Endereço"
                            />

                            </div> 
                    <br />   
                     <strong>Numero</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Num}
                              onChange={t=>setNum(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Numero"
                            />

                            </div> 
                    <br />   
                      <strong>Bairro</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Bairro}
                              onChange={t=>setBairro(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Bairro"
                            />

                            </div> 
                    <br />   
                  <strong>Cidade</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Cidade}
                              onChange={t=>setCidade(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite a Cidade"
                            />

                            </div> 
                    <br /> 
                    <strong>Estado</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Estado}
                              onChange={t=>setEstado(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite a Estado"
                            />

                            </div> 
                    <br />   
                  
                     
                    
                    </address>
                   </div>
                    <div className="col-sm-4 invoice-col">
                    <address>
                     
                   
                    </address>
                   </div>
              </div>
              <div className="row no-print">
              </div>
              
            
            </div> 
            </div>
            </div>
            </div>
          </section>
  
</div>

            </>
        );
}